import { BehaviorSubject } from "rxjs";

const viewerInfo$ = new BehaviorSubject(['']);

export function addViewerInfo(info: string) {
    console.debug('addViewerInfo', info);
    viewerInfo$.next([...viewerInfo$.value, info]);
}

export default viewerInfo$;